// Module « patrimoine » : logements, immeubles, propriétaires, SCI et indivision, reprise d'une location en cours,
// vérification du bailleur, diagnostics et règles locales (F-002, F-005, F-006, F-007, F-008, F-089, F-090).
import type { FrontModule } from "@core/modules";
import "./patrimoine.css";
import { BuildingPage, BuildingsPage } from "./buildings";
import { PatrimoineDashboard } from "./dashboard";
import { ImportDetailPage, ImportLeasePage } from "./importLease";
import { OwnerPage, OwnersPage } from "./owners";
import { PropertiesListPage, PropertyPage } from "./properties";
import { TeamReviewPage } from "./verification";

export const module: FrontModule = {
  name: "patrimoine",
  orgRoutes: [
    { path: "logements", element: <PropertiesListPage /> },
    { path: "logements/importer-une-location", element: <ImportLeasePage /> },
    { path: "logements/reprises/:importId", element: <ImportDetailPage /> },
    { path: "logements/:propertyId", element: <PropertyPage /> },
    { path: "immeubles", element: <BuildingsPage /> },
    { path: "immeubles/:buildingId", element: <BuildingPage /> },
    { path: "proprietaires", element: <OwnersPage /> },
    { path: "proprietaires/:ownerId", element: <OwnerPage /> },
  ],
  nav: [
    { to: "logements", label: "Logements", section: "Location", perm: "read", order: 1 },
    { to: "immeubles", label: "Immeubles", section: "Immeubles", perm: "read", order: 10 },
    { to: "proprietaires", label: "Propriétaires", section: "Espace", perm: "read", order: 10 },
  ],
  // Espace d'examen de l'équipe Bailivo : sans lien de navigation, la route répond « réservé » aux autres comptes.
  accountRoutes: [{ path: "/moi/equipe/verifications-bailleurs", element: <TeamReviewPage /> }],
  Dashboard: PatrimoineDashboard,
};
